/*global Ractive, RedmarineUXTemplates, BaseComponent */

// Add component to Global Ractive object
Ractive.components['ux-rating'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxratingUxrating,

	// any default data
	data: {
		component: 'ux-rating',
		getStars: function(stars) {
			var name = (_.floor(stars * 2) * 5);
			return name < 10 ? '0' + name : name;
		},
		getTitle: function(stars) {
			return stars + ' out of 5 stars';
		}
	},

	computed: {
		starClass: function() {
			return this.get('getStars')(this.get('rating'));
		},
		title: function() {
			return this.get('getTitle')(this.get('rating'));
		}
	}

});
